export default __webpack_public_path__ + "static/media/team-big.53114884.svg";